/**
 * ScrollableSection Component
 */

import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import SectionTitle from '../SectionTitle';

interface IOwnProps<TItem> {
  className?: string;
  data: TItem[];
  id: string;
  subtitle?: string;
  title?: string;
  children(item: TItem | null, index: number): React.ReactNode;
}

export type ScrollableSectionProps<TItem> = IOwnProps<TItem>;

const classes = new BEM('scrollable-section');

export default class ScrollableSection<TItem> extends React.Component<IOwnProps<TItem>, any> {

  render() {
    const {
      children,
      className,
      data,
      id,
      subtitle,
      title,
    } = this.props;

    return (
      <div {...classes('', id, className) }>
        {title && <SectionTitle title={title} subtitle={subtitle} {...classes('title', '') } />}
        <div {...classes('list-wrapper') }>
          <ul {...classes('list') }>{data.map((item, index) => (
            <li key={`${id}-${index}`} {...classes('list__item') }>
              {children(item, index)}
            </li>
          ))}</ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/content/ScrollableSection/index.tsx